(function () {
  var checkjQuery = function () {
    if (window.jQuery) {
      function addProductToCart(btnClicked) {
        // e.preventDefault();
        console.log(btnClicked);

        $(btnClicked)
          .parent(".buy-buttons_head")
          .parent(".buy_btn_plus_qty_selector-head")
          .siblings(".buy-btn-prev")
          .find(".product-form__buttons")
          .children("button")
          .trigger("click");
      }

      window.SLIDECART_UPDATED = function (cart) {
        // Fires whenevr slide cart has updated
        $(".header__icon--cart").load(" .header__icon--cart");
      };

      $(document).ready(function () {
        let input;
        let variant_id;
        setTimeout(() => {
          $(".header__icon--cart").click(function (e) {
            if (localStorage.getItem("bundle") == "false") {
              $(".quantity-selector").show();
            } else {
              $(".quantity-selector").hide();
              $("button.remove").click(function (e) {
                e.preventDefault();
                localStorage.removeItem("bundle");
                location.href = "/cart/clear";
              });
            }
          });
        }, "1000");
        /*setTimeout(() => {
        $(".item button.remove").click(function(e) {
            if (localStorage.getItem("bundle") != "false") {
                e.preventDefault();
                $.ajax({
                    type: "POST",
                    url: '/cart/clear.js',
                    dataType: 'json',
                    success: function (data) {
                        $.ajax({
                            type: 'GET',
                            url: '/cart.js',
                            cache: false,
                            dataType: 'json',
                            success: function(cart) {
                                $('.quantity-selector').show();
                                localStorage.removeItem("bundle");
                                location.reload();
                            }
                        });
                    },
                    error: function (request, error) {
                        alert("Cart Error: " + JSON.stringify(request.responseJSON.description));
                    }
                });
            }
        });
    }, "3000");*/

        $(document).on(
          "click",
          ".conditional-addToCart-button-collection .addToCart-btn",
          function (e) {
            e.preventDefault();

            var input = $(this)
              .parents(".card__information.card__information--style-collection")
              .siblings(".globo-container")
              .find(".swatches-options input[type='radio']:checked")
              .attr("data-variantid");

            var variant_id;
            if (input === undefined) {
              variant_id = $(this).attr("variant-id");
            } else {
              variant_id = input;
            }

            // Call the function to add item to cart
            addItemToCart(variant_id);

            // Uncomment and modify the following lines as needed
            // let quantity = 1;
            // window.SLIDECART_ADD_TO_CART = function({ variant_id, quantity }) {
            //   // Fires whenever an item has been added to cart
            // }
          }
        );

        // $(".conditional-addToCart-button-collection .addToCart-btn").click(
        //   function (e) {
        //     e.preventDefault();
        //     input = $(this)
        //       .parents(".card__information.card__information--style-collection")
        //       .siblings(".globo-container")
        //       .find(".swatches-options input[type='radio']:checked")
        //       .attr("data-variantid");
        //     if (input == undefined) {
        //       variant_id = $(this).attr("variant-id");
        //     } else {
        //       variant_id = input;
        //     }
        //     // console.log(variant_id);
        //     addItemToCart(variant_id);
        //     // let quantity = 1;
        //     // window.SLIDECART_ADD_TO_CART = function({ variant_id, quantity }) {
        //     //   // Fires whenever an item has been added to cart
        //     // }
        //   }
        // );

        function addItemToCart(variant_id) {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              quantity: 1,
              id: variant_id,
            },
            dataType: "json",
            success: function (data) {
              //console.log('added to cart success', data.id);
              // window.location.href = '/cart';

              let cartDrawer = document.querySelector("#slidecarthq");
              //console.log('cartDrawer', cartDrawer);
              if (cartDrawer) {
                setTimeout(function () {
                  // console.log('cart updated 2')
                  //changes h2 text
                  let h2 = cartDrawer.querySelector("header h2");
                  h2.innerHTML = `YOUR CART <span class="cart-count">1</span>`;

                  //change btn svg
                  let closeBtn = cartDrawer.querySelector("header button");
                  closeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="21" viewBox="0 0 12 21" fill="none"><path d="M11 1L1.5 10.5L11 20" stroke="black"/></svg>`;

                  //append text to header
                  let cartHeader = cartDrawer.querySelector("header");
                  let span = document.createElement("span");
                  span.setAttribute("class", "cart-header-info");
                  span.textContent = "Unlock Free Shipping and Major Savings";
                  cartHeader.appendChild(span);

                  //append svg to checkout
                  let checkoutBtn = cartDrawer.querySelector(
                    'button[name="checkout"]'
                  );
                  if (checkoutBtn) {
                    checkoutBtn.innerHTML = `Checkout
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      <path d="M12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      <path d="M17 22H7C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>`;
                  }

                  //append free shipping text and payment icons
                  let cartCustomHTML = cartDrawer.querySelector(".custom-html");
                  if (cartCustomHTML) {
                    // let newEle = document.createElement('div');
                    // newEle.setAttribute('class', 'free-ship-pay-icons');
                    let newEle = `<div class="free-ship-pay-icons">
                      <span> Free Tracked US Shipping | Ships within 1 Business Day</span>
                      <img src="https://cdn.shopify.com/s/files/1/0206/4926/files/image_1_8c18c921-136b-472e-9d10-cbdbed15cdbd.png?v=1715160188" width="auto" height="50">
                    </div>
                    `;
                    // cartCustomHTML.prepend(newEle);
                    cartCustomHTML.innerHTML = newEle;
                  }
                }, 500);
              }

              // Update Slide Cart (refetches the cart object)
              window.SLIDECART_UPDATE(data);
              // Open slide cart
              window.SLIDECART_OPEN();
            },
          });
        }

        // load product on gifts collection
        // let minValue = 0;
        // let maxValue = 0;
        // $(".button.gifts").click(function(e){
        //     e.preventDefault();
        //     minValue = $(this).attr('min');
        //     maxValue = $(this).attr('max');
        //     console.log(minValue+ " - " +maxValue)
        //     $("input#Filter-Price-GTE[name='filter.v.price.gte']").attr('min', minValue);
        //     $("input#Filter-Price-GTE[name='filter.v.price.gte']").val(minValue);
        //     $("input#Filter-Price-GTE[name='filter.v.price.gte']").change();
        //     $("input#Filter-Price-GTE[name='filter.v.price.gte']").keydown();
        //     $("input#Filter-Price-LTE[name='filter.v.price.lte']").attr('max', maxValue);
        //     $("input#Filter-Price-LTE[name='filter.v.price.lte']").val(maxValue);
        //     $("input#Filter-Price-LTE[name='filter.v.price.lte']").change();
        //     $("input#Filter-Price-LTE[name='filter.v.price.lte']").keydown();
        // });

        // hide and show product images
        $(".grid__item .view-more-button.more").click(function (e) {
          e.preventDefault();
          $(this).hide();
          $(this).siblings(".view-more-button.less").show();
          $(this)
            .parent("div")
            .siblings(".product__media-list")
            .removeClass("h-1000");
          console.log("Show more btn clicked!");
        });

        $(".grid__item .view-more-button.less").click(function (e) {
          e.preventDefault();
          $(this).hide();
          $(this).siblings(".view-more-button.more").show();
          $(this)
            .parent("div")
            .siblings(".product__media-list")
            .addClass("h-1000");
          console.log("Show less btn clicked!");
        });

        // $(".preloader-head.onPgaeLoad").hide();

        // Collection read more
        $(
          ".collection--card-wrapper .read-more-collection-description-btn"
        ).click(function () {
          if (
            !$(this)
              .siblings(".read-more-collection-description")
              .is(":visible")
          ) {
            $(".read-more-collection-description").slideUp();
            $(this).siblings(".read-more-collection-description").slideDown();
          } else {
            $(this).siblings(".read-more-collection-description").slideUp();
          }
        });

        // $(".globo-swatch-list").each(function(){
        //     var $this = $(this);
        //     if ($this.find('div.swatch--gl').length > 1) { //if looking for direct descendants then do .children('div').length
        //         $this.addClass("glo-swatches-styles");
        //     }
        // });

        // $(".buy-buttons_head .add-to-cart-product-page").click(function(e){
        //     e.preventDefault();
        //     console.log("Clicked");
        //     $(this).parent(".buy-buttons_head").parent(".buy_btn_plus_qty_selector-head").siblings(".buy-btn-prev")
        //     .find(".product-form__buttons").children("button").trigger("click");
        // });

        // announcement-bar-slider
        (function () {
          var checkOwlCarousel = function () {
            if (typeof $.fn.owlCarousel !== 'undefined') {
              // $("#announcement-bar-slider").carousel({
              //   // 4 seconds
              //   interval: 1000 * 3,
              // });
            } else {
              setTimeout(checkOwlCarousel, 100); // Check again after 100ms
            }
          };
          checkOwlCarousel();
        })();

        // FAQs
        $(".faq .content").slideUp();
        $(".faq .minus").hide();
        $(".faq .collapsible").click(function () {
          $(this).children(".plus").toggle();
          $(this).children(".minus").toggle();
          $(this).siblings(".content").slideToggle();
        });

        // hide and show collection description
        $(".collection-desc__next .nextRead").click(function (e) {
          e.preventDefault();
          $(this)
            .parents(".collection-desc__next")
            .siblings(".collection-bottom__description")
            .hide();
          $(this)
            .parents(".collection-desc__next")
            .siblings(".collection-bottom__description-full")
            .slideDown();
          $(this).hide();
        });

        // home page new Arrivals collection slider
        $(
          ".slider-and-video__buttons-wrapper .slider-and-video__button-next, .slider-reviews__buttons-wrapper .slider-reviews__button-next"
        ).click(function () {
          $(
            ".slider-and-video .slider-and-video__slider-wrapper .swiper-wrapper, .slider-reviews .outer-box #H-S"
          ).animate(
            {
              scrollLeft: "+=350px",
            },
            "slow"
          );
        });

        $(
          ".slider-and-video__buttons-wrapper .slider-and-video__button-prev, .slider-reviews__buttons-wrapper .slider-reviews__button-prev"
        ).click(function () {
          $(
            ".slider-and-video .slider-and-video__slider-wrapper .swiper-wrapper, .slider-reviews .outer-box #H-S"
          ).animate(
            {
              scrollLeft: "-=350px",
            },
            "slow"
          );
        });

        // complete the look collection slider
        $(".related-products-wrapper .related-product-btn-next").click(
          function () {
            $(this)
              .parents(".related-products-wrapper")
              .siblings("product-recommendations")
              .children(".product-grid")
              .animate(
                {
                  scrollLeft: "+=360px",
                },
                "slow"
              );
          }
        );

        $(".related-products-wrapper .related-product-btn-prev").click(
          function () {
            $(this)
              .parents(".related-products-wrapper")
              .siblings("product-recommendations")
              .children(".product-grid")
              .animate(
                {
                  scrollLeft: "-=360px",
                },
                "slow"
              );
          }
        );

        // recently viewed collection slider
        $(
          ".recently-viewed-arrow-wrapper .recently-viewed-arrow-btn-next"
        ).click(function () {
          $(this)
            .parents(".recently-viewed-arrow-wrapper")
            .siblings(".recently-viewed.product-grid")
            .animate(
              {
                scrollLeft: "+=360px",
              },
              "slow"
            );
        });

        $(
          ".recently-viewed-arrow-wrapper .recently-viewed-arrow-btn-prev"
        ).click(function () {
          $(this)
            .parents(".recently-viewed-arrow-wrapper")
            .siblings(".recently-viewed.product-grid")
            .animate(
              {
                scrollLeft: "-=360px",
              },
              "slow"
            );
        });

        // open header menu on hover
        let items = document
          .querySelector(".header__inline-menu")
          .querySelectorAll("details");
        enableMenuOpenOnHover(items);

        let headerInlineMenu2 = document.querySelector(".header__inline-menu2");
        if (headerInlineMenu2) {
          let items2 = headerInlineMenu2.querySelectorAll("details");
          enableMenuOpenOnHover(items2);
        } else {
          console.error(
            "Element with class '.header__inline-menu2' not found."
          );
        }

        // let items2 = document.querySelector(".header__inline-menu2").querySelectorAll("details");
        //  enableMenuOpenOnHover(items2);

        function enableMenuOpenOnHover(items) {
          items.forEach((item) => {
            item.addEventListener("mouseover", () => {
              item.setAttribute("open", true);
              item.querySelector("ul").addEventListener("mouseleave", () => {
                item.removeAttribute("open");
              });
              item.addEventListener("mouseleave", () => {
                item.removeAttribute("open");
              });
            });
          });
        }

        // update price when variant changed
        // let price = $(".hide-price-main-product .price__container .price__regular .price-hidden").attr('price');
        // $(".hide-price-main-product .price__container .price__regular .price-hidden").on('load', function(){
        //     price = $(this).attr('price');
        //     console.log("Changed price: " + price);
        //     $(".buy-buttons_head .changed-price").text(price);
        // });
        // console.log(price);

        // Show selected variant -- GLOBO app
        setTimeout(() => {
          let swatchVal;
          let totalSwatches = $(
            ".product__info-wrapper .product__info-container .globo-swatch-list .swatch--gl"
          );
          let selector;
          if (totalSwatches.length > 0) {
            for (let i = 0; i < totalSwatches.length; i++) {
              selector = $(
                ".product__info-wrapper .product__info-container .swatch--gl[data-option-index='" +
                i +
                "'] .select-option input[type='radio']:checked"
              );
              console.log(i);
              swatchVal = $(selector).attr("value");
              // $(selector).click();
              $(
                ".product__info-wrapper .product__info-container .swatch--gl[data-option-index='" +
                i +
                "'] .name-option .name-variant"
              ).text(": " + swatchVal);
              console.log(swatchVal);
            }
          }
        }, 4000);

        // setTimeout(() => {
        //     if (window.location.pathname.includes("/silver")) {
        //         console.log("/silver");
        //         $(".swatches-options input[value='Gold']").hide();
        //         $(".swatches-options input[value='Gold']").siblings("label.swatch-anchor").hide();
        //     }
        //     if (window.location.pathname.includes("/gold")) {
        //         console.log("/gold");
        //         $(".swatches-options input[value='Silver']").hide();
        //         $(".swatches-options input[value='Silver']").siblings("label.swatch-anchor").hide();
        //     }
        // }, 4000);
      });
    } else {
      setTimeout(checkjQuery, 100);
    }
  };
  checkjQuery();
})();
